import { PATH_NAME_LIST_VIEW_MORE } from '@/common/resources/router.const'

/**
 * 카탈로그 view more 클릭 시 view more 페이지로 이동하는 라우터 객체 반환
 * @param url
 * @returns { any }
 */
export const navigateViewMoreCatalog = (url) => {
  console.log('catalog view more url:', url)
  const [_, uiCode = ''] = url.split('/viewmore?code=')

  console.log(_, uiCode)

  return {
    name: PATH_NAME_LIST_VIEW_MORE,
    query: {
      code: uiCode,
    },
  }
}
